'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var coreRenderer = require('@tempi/core-renderer');
var React = require('react');
var index = require('../../types/index.js');
var ui = require('../container/ui.js');
var ui$1 = require('../row/ui.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PbSection = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      children,
      commonStyle,
      verticalAlignment,
      widthType,
      row,
      gutter
    } = _a, other = __objRest(_a, [
      "children",
      "commonStyle",
      "verticalAlignment",
      "widthType",
      "row",
      "gutter"
    ]);
    const { maxWidth } = commonStyle;
    let rowStyle = row == null ? void 0 : row.commonStyle;
    rowStyle = __spreadValues({ minHeight: "inherit", height: "100%" }, rowStyle);
    if (rowStyle == null ? void 0 : rowStyle.maxWidth) {
      rowStyle = __spreadValues({
        marginLeft: "auto !important",
        marginRight: "auto !important"
      }, rowStyle);
    }
    return /* @__PURE__ */ jsxRuntime.jsxs(ui.PbContainer, __spreadProps(__spreadValues({
      maxWidth,
      fluid: widthType === index.WidthTypeEnum.full,
      ref,
      commonStyle
    }, other), {
      children: [
        (commonStyle == null ? void 0 : commonStyle.backgroundVideo) && /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BackgroundVideo, __spreadValues({}, commonStyle.backgroundVideo)),
        /* @__PURE__ */ jsxRuntime.jsx(ui$1.PbRow, {
          commonStyle: rowStyle,
          verticalAlignment,
          gutter,
          children
        })
      ]
    }));
  }
);
PbSection.displayName = "Section";

exports.PbSection = PbSection;
